import * as ActionTypes from '../constants/actionTypes'
import { actionGetCount, actionGetPage } from '../api/action'

export const fetchItems = (params = {}) => (dispatch) => {
  dispatch({ type: ActionTypes.ACTIONLIST_FETCHITEMS_LOAD })

  actionGetCount(params).then((res) => {
    const total = parseInt(res.result.n_count)

    actionGetPage(params).then((res) => {
      const items = res.result

      const newItems = items

      items.map((obj, key) =>
        newItems[key].n_disable = obj.n_disable === '1')

      dispatch({
        type: ActionTypes.ACTIONLIST_FETCHITEMS_SUCCEED,
        items: newItems,
        total,
      })
    }).catch((err) => {
      dispatch({
        type: ActionTypes.ACTIONLIST_FETCHITEMS_FAIL,
        fetchItemsError: 'Ошибка получения списка акций',
      })
    })
  }).catch((err) => {
    dispatch({
      type: ActionTypes.ACTIONLIST_FETCHITEMS_FAIL,
      fetchItemsError: 'Ошибка получения кол-ва акций',
    })
  })
}

export const changeTable = params => (dispatch) => {
  const { pagination = {}, filters = {}, sorter = {} } = params
  dispatch({
    type: ActionTypes.ACTIONLIST_CHANGETABLE_CHANGE,
    pagination,
    filters,
    sorter,
  })
}

export const searchTable = ({ isSearching }) => (dispatch) => {
  dispatch({
    type: ActionTypes.ACTIONLIST_SEARCHTABLE_SEARCH,
    isSearching,
  })
}

export const editSearch = params => (dispatch) => {
  const { search } = params
  dispatch({
    type: ActionTypes.ACTIONLIST_SEARCHTABLE_EDIT,
    search,
  })
}



// WEBPACK FOOTER //
// src/actions/actionList.js